import type { CSSProperties } from "react";
import brand from "../../../../assets/brand/source.json";
import { cn } from "../lib/cn";

type BrandTone = "auto" | "light" | "dark" | "mono";

// Dùng chung hình học với mobile và script xuất icon; logo không có chuyển động.
export function BrandMark({ size = 40, tone = "auto", label, className }: {
  size?: number;
  tone?: BrandTone;
  label?: string;
  className?: string;
}) {
  const colors = tone === "light" || tone === "dark" ? brand.palette[tone] : null;
  const style = colors ? { "--brand-body": colors.primary, "--brand-node": colors.accent } as CSSProperties : undefined;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={brand.geometry.viewBox}
      width={size}
      height={size}
      className={cn("brand-mark shrink-0", className)}
      style={style}
      data-brand-mark="l-signal"
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path d={brand.geometry.body} fill={tone === "mono" ? "currentColor" : "var(--brand-body, hsl(var(--primary)))"} fillRule="evenodd" />
      <rect {...brand.geometry.node} fill={tone === "mono" ? "currentColor" : "var(--brand-node, hsl(var(--accent)))"} />
    </svg>
  );
}

// Khi link đã có tên truy cập, chỉ ẩn phần mark để tránh đọc lặp tên thương hiệu.
export function BrandLockup({ showName = true, tagline = brand.tagline, tone = "auto", className }: {
  showName?: boolean;
  tagline?: string;
  tone?: BrandTone;
  className?: string;
}) {
  const colors = tone === "light" || tone === "dark" ? brand.palette[tone] : null;
  return (
    <span className={cn("brand-lockup inline-flex min-w-0 items-center gap-3", className)} style={colors ? { color: colors.text } : undefined}>
      <BrandMark size={40} tone={tone} />
      {showName && (
        <span className="min-w-0">
          <strong className="block whitespace-nowrap text-sm font-extrabold tracking-[-0.04em]">{brand.name}</strong>
          {tagline && <span className="block whitespace-nowrap text-[8px] font-bold tracking-[0.16em] text-primary" style={colors ? { color: colors.muted } : undefined}>{tagline}</span>}
        </span>
      )}
    </span>
  );
}
